module.exports = __webpack_public_path__ + "static/media/avatar-08.eb3dfdc7.svg";